import React from 'react';
import {
    LoginContainer,
    FormDiv,
    Flex,
    Options as OptionsLink
} from './styled';
import {Button} from '@material-ui/core';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            marginBottom: 10,
            width: '100%',
            '& > * + *': {
                marginTop: theme.spacing(2),
            },
        },
        button: {
            marginTop: 20,
            width: '100%',
        },
        step: {
            backgroundColor: 'transparent'
        },
    }),
);

const Options: React.FC = () => {
    document.title = "Controle de Frete - Sultan Veste a Casa";

    const classes = useStyles();   

    return (
        <LoginContainer>            
            <Flex>
                <FormDiv>
                    <h2 className="centro">Escolha o tipo de documento</h2>
                    <OptionsLink>
                        <Link title="CTE" to={`${process.env.PUBLIC_URL}/usuario/controle-de-frete/cte`}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                className={classes.button}
                            >
                                CTE
                            </Button> 
                        </Link>                            
                        <Link title="Romaneio" to={`${process.env.PUBLIC_URL}/usuario/controle-de-frete/romaneio`}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                className={classes.button}
                            >
                                Romaneio
                            </Button> 
                        </Link>   
                        <Link title="Serviço" to={`${process.env.PUBLIC_URL}/usuario/controle-de-frete/servico`}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                className={classes.button}
                            >
                                Serviço
                            </Button> 
                        </Link>    
                        <Link title="Recibo" to={`${process.env.PUBLIC_URL}/usuario/controle-de-frete/recibo`}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                className={classes.button}
                            >
                                Recibo
                            </Button> 
                        </Link>   
                        <Link title="Voltar" to={`${process.env.PUBLIC_URL}/usuario/controle-de-frete`}>
                            <Button
                                variant="contained"
                                color="secondary"
                                size="large"
                                className={classes.button}
                            >
                                VOLTAR
                            </Button> 
                        </Link>
                    </OptionsLink>
                </FormDiv>
            </Flex>                          
        </LoginContainer>
    );
};

export default Options;